module.exports = __webpack_public_path__ + "static/media/card-worker-in-today-icon.31604ee0.svg";